import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";

const EventType = ({
  apiAddFunc,
  buttonLabel,
  listComponent: ListComponent,
  editFormComponent: EditFormComponent,
  component,
  ...props
}) => {
  const [addnewform, setAddNewForm] = React.useState(false);

  const handleSubmit = async (data) => {
    const isActivity = component === "activityTypes";
    const label = isActivity ? "Activity Type" : "Time Type";

    try {
      await apiAddFunc(data);
      toast.success(`${label} Added Successfully`);
    } catch {
    } finally {
      setAddNewForm(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn setting-btn`}
          onClick={() => {
            setAddNewForm(true);
            props.open();
          }}
        >
          Add {buttonLabel.split(" ")[0]}<br />
          {buttonLabel.split(" ")[1]}
        </Button>
      </div>
      <div
        className="flex-grow-1 mb-2"
        style={{ minHeight: 0 }}
      >
        <ListComponent />
      </div>
      {
        addnewform && (
          <EditFormComponent
            cancelEdit={() => {
              setAddNewForm(false);
            }}
            onSubmit={handleSubmit}
            type="addNew"
          />
        )
      }
    </div>
  );
};

export default EventType;
